import { lazy } from "react";

const SystemDocumentVerificationPage = lazy(
  () =>
    import(
      "@/widgets/system-admin/document-verification/DocumentVerificationPage"
    ),
);

// Review happens in-page via DocumentVerificationDrawer (CustomDrawer),
// not a separate route — a single index route is all this needs.
const SystemDocumentVerificationRoutes = {
  path: "document-verification",
  children: [{ index: true, element: <SystemDocumentVerificationPage /> }],
};

export default SystemDocumentVerificationRoutes;
